import { Db } from 'mongodb'
import { schema, types } from 'papr'

export const GH_ACTIVITY_LOG_STATUS = ['READY' as const, 'BUILDING' as const, 'FAILED' as const]
const THIRTY_DAYS_IN_SECONDS = 60 * 60 * 24 * 30

export const githubActivityLogsCollectionName = 'docsGitHubActivityLogs'
const GH_ACTIVITY_LOG_ERROR_CODES = [
	'CONFIGURATION_ERROR' as const,
	'DUPLICATE_SLUGS' as const,
	'DUPLICATE_PATHS' as const,
	'MISSING_FILES' as const,
	'CONTENT_ERROR' as const,
]

const githubActivityLogError = types.object({
	code: types.enum(GH_ACTIVITY_LOG_ERROR_CODES, { required: true }),
	messages: types.array(types.string({ required: true })),
})
export const githubActivityLogSchema = schema(
	{
		projectId: types.objectId({ required: true }),
		branchName: types.string({ required: true }),
		status: types.enum(GH_ACTIVITY_LOG_STATUS, { required: true }),
		/**
		 * Additional info on the activity, especially for `FAILED` status
		 */
		message: types.string(),
		gitCommitId: types.string({ required: true }),
		gitCommitMessage: types.string({ required: true }),
		gitCommitUrl: types.string({ required: true }),
		deploymentType: types.enum(['PREVIEW' as const, 'PRODUCTION' as const], { required: true }),
		errors: types.array(githubActivityLogError),
	},
	{
		timestamps: true,
	},
)

export const createDocsGithubActivityLogsIndex = async (db: Db) => {
	await db.createIndex(
		githubActivityLogsCollectionName,
		{
			createdAt: 1,
		},
		{
			expireAfterSeconds: THIRTY_DAYS_IN_SECONDS,
		},
	)
}

export type DocsGithubActivityLogError = typeof githubActivityLogError
export type DocsGithubActivityLogDocument = (typeof githubActivityLogSchema)[0]
export type DocsGithubActivityLogSchemaOptions = (typeof githubActivityLogSchema)[1]
